import React from "react";
import ReactDom from "react-dom";
import App from "./pages/_app";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom";
import { Auth0ProviderWithHistory } from "./auth0-provider-with-history";

ReactDom.render(  
  <React.StrictMode>
    <BrowserRouter basename="/">
      <Auth0ProviderWithHistory>
        <App />
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </React.StrictMode>, 
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
